(function () {
  'use strict';

  angular.module('sempraWebapp').factory('campaignTemplateActions', campaignTemplateActionsFactory);

  /** @ngInject */
  function campaignTemplateActionsFactory ($q, api, dispatcher, ActionTypesEnum) {
    return {
      getCampaignTemplates: getCampaignTemplates,
      getCampaignTemplateById: getCampaignTemplateById,
      createCampaignTemplate: createCampaignTemplate,
      updateCampaignTemplate: updateCampaignTemplate,
      deleteCampaignTemplate: deleteCampaignTemplate
    };

    function getCampaignTemplates () {
      var deferred = $q.defer();

      api.getCampaignTemplates().then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function getCampaignTemplateById (campaignTemplateId) {
      var deferred = $q.defer();

      api.getCampaignTemplateById(campaignTemplateId).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function createCampaignTemplate (campaignTemplate) {
      var deferred = $q.defer();

      api.createCampaignTemplate(campaignTemplate).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function updateCampaignTemplate (campaignTemplate) {
      var deferred = $q.defer();

      api.updateCampaignTemplate(campaignTemplate).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function deleteCampaignTemplate (campaignTemplateId) {
      var deferred = $q.defer();

      api.deleteCampaignTemplate(campaignTemplateId).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

  }
})();
